<mat-card class="p-12">
    <b>{{"CAPTCHA.TYPE_CHARACTERS" | translate}}</b>
    <div fxLayout="row wrap" *ngIf="!loading">
        <div fxFlex.gt-sm="25%" fxFlex.lt-sm="100%" class="my-12">
            <object type="image/png"
                [data]="base64"
                width="auto"
                height="auto">
            </object>
        </div>
        <div fxFlex.gt-sm="49%" fxFlex.lt-sm="100%" class="m-12 mx-8" [formGroup]="form">
            <mat-form-field appearance="outline" style="width: 100%;">
                <input matInput formControlName='captcha' style="width: 100%;" [readonly]="disabledCaptcha"/>
            </mat-form-field>
        </div>
    </div>
    <div *ngIf="loading">
        <mat-spinner diameter="25"></mat-spinner>
    </div>
    <div align="end">
        <button mat-raised-button color="primary" class="m-4" (click)="onRefreshCaptcha()"
        [disabled]="loading || disabledCaptcha">
            {{"CAPTCHA.REFRESH" | translate}}
        </button>
        <button mat-raised-button color="accent" class="m-4" (click)="onValidateCaptcha()"
        [disabled]="form.get('captcha').invalid || loading || disabledCaptcha">
            {{"CAPTCHA.VALIDATE" | translate}}
        </button>
    </div>
</mat-card>
